import MediaFusionIndex from '../containers/mediaFusionIndex';
import React from "react";
import ZykTabList from "../components/ZykTabList";
import {NO_FRAME} from "../constants";
import NewsDetail from "../components/zyk/news_detail";
import MyStory from "../containers/myStory";
import StoryMoneyList from "../components/storyMoneyList";
import StorageList from "../containers/StorageList";
import WeChatFansManage from "../components/weChatFans";
import AuditStoryList from "../components/auditStoryList";
import AuditViewList from "../components/auditViewList";
import ImageSourceList from "../view/mediaRelease/imageSource/ImageSourceList";
import LinkSourceList from "../view/mediaRelease/linkSource/linkSourceList";
import ResourcePathConfig from "../components/ResourcePathConfig";
import MessageNotification from "../components/MessageNotification";
import WeiChatPublish from "../containers/weiChatPublish";
import PublishRecord from "../containers/publishRecord/publishRecord";
import StuffList from "../containers/stuffList";
import ContentModal from "../containers/contentModal";
import EditMaterial from "../containers/editMaterial";
import WeiChatTagSelect from "../containers/weiChatTagSelect";


import {ViewRouter} from "../route/ViewRouter"
import EditorComponents135 from "../view/components/editor135/EditorComponents135";
import DownLoadTaskList from "../containers/DownLoadTaskList";
import PmsStaticMyDesk from "../view/desktop/PmsStaticMyDesk";

import DataManage from "../components/mediaFusion/DataManage";
import ColumnManage from "../components/mediaFusion/ColumnManage";
import  Notice from"../view/notice/Notice"
import TopicSelectionList from "../components/topicSelection/topicSelectionList";

//专题项目
import MajorProjectList from '../components/major-projects/projects/list';
import PictureWrap from '../components/resource-wrap/picture-wrap';
import VideoWrap from '../components/resource-wrap/video-wrap';
import AttachmentWrap from '../components/resource-wrap/attachment-wrap';
import ResourceList from '../components/resource-list/';
import PreviewPage from '../components/resource-list/previewPage';
import Login from "../containers/login";
import IndexLayout from "../containers/desktop/indexLayout";
import MenuList from "../view/sysManagement/organizationalStructure/menu/MenuList";
import ColumnList from "../containers/mmp/column/ColumnList";
import ArticleList from "../containers/mmp/article/ArticleList";
import Splash from "../containers/mmp/article/Splash";
import RmList from "../containers/mmp/rm/RmList";
import NotColumnPage from "../containers/mmp/article/NotColumnPage";
import UserList from "../containers/mmp/userManage/UserList";
import RmDeliverRelation from "../containers/mmp/rmDeliverRelation/RmDeliverRelation";
import ConvenienceServeList from "../containers/mmp/convenienceServe/ConvenienceServeList";
import OpinionManageList from "../containers/mmp/opinionManage/OpinionManageList";
import MessagePushList from "../containers/mmp/messagePush/MessagePushList";
import PointsRule from '../containers/mmp/pointsRule/PointsRule'
import PointsManagement from '../containers/mmp/pointsRule/PointsManagement'
import  HonorManagement from '../containers/mmp/pointsRule/HonorManagement'
const config = {
    pms:{
        host: "",
        currentUserUrl: "/cm-sites-pms/user/getCurrentUser",//获取当前登录用户的信息
        navigateUrl: "/cm-sites-pms/user/getMenuJSON",
        logoutUrl:"/cm-sites-pms/logout",
        loginUrl:"/cm-sites-pms/login",
        loginPage:"/cm-sites/pms/framereact/index.html#/login",
        logoutHref:"/cm-sites/pms/framereact/index.html#/login",
        zyk:"/cm-sites-pms/",
        wsURL: "/cm-sites-pms/index/ws",//获取websocket名称通道的地址
        beginAuthURL: "/cm-sites-pms/index/beginAuthURL",//开始校验是否异地登录了
        route:[
            ...ViewRouter,

            // {path:"/login", component:Login ,frame:NO_FRAME },
            //专题项目页面
            {path:"/major/projects", component: MajorProjectList},
            //图片池
            {path:"/picture/wrap", component: PictureWrap},
            //稿件池
            {path: "/video/wrap", component: VideoWrap},
            //附件池
            {path: "/attachment/wrap", component: AttachmentWrap},
            //媒体列表
            {path: "/resource/list", component: ResourceList},
            //预览
            {path: "/preview/page/:id/:type", component: PreviewPage,frame:NO_FRAME },



            {path:"/rmt/desktop/:key", component:IndexLayout},

            {path:"/view/:type/:id", component:PmsStaticMyDesk},
            // {path:"/xiaoxi/list", framePath:"/cm-sites/pms/xiaoxi/list.html"},
            {path:"/xiaoxi/list", component:MessageNotification},
            {path:"/resourcePathConfig/resourcePathConfig", component:ResourcePathConfig},
            {path:"/topicSelectionList/topicSelectionList", component:TopicSelectionList},

            //活动资源页面
            // {path:"/website/wangzhan/:mediaCode/activityStory", framePath:"/cm-sites/pms/website/activityStory.html"},
            {path:"/website/wangzhan/:currentMedia/:type", framePath:"/cm-sites/pms/website/wangzhan.html"},
            {path:"/website/wangzhan/:currentMedia/:type/:otherMedia", framePath:"/cm-sites/pms/website/wangzhan.html"},
            //微信微博链接稿件
            {path:"/website/wechatList", framePath:"/cm-sites/pms/website/wechat/wechatList.html"},
            {path:"/website/weiboList", framePath:"/cm-sites/pms/website/weibo/weiboList.html"},

            {path:"/wechat/weixing/:currentMedia", framePath:"/cm-sites/pms/wechat/weixing.html"},
            {path:"/weibo/weiboIndex/weibotoguaoziyuan/:currentMedia", framePath:"/cm-sites/pms/wechat/weixing.html"},

            {path:"/wechat/weixing/wechatActivity/:currentMedia", framePath:"/cm-sites/pms/wechat/wechatActivity.html"},
            {path:"/wechat/weixing/:currentMedia/wechatActivity/:currentMedia", framePath:"/cm-sites/pms/wechat/wechatActivity.html"},
            {path:"/wechat/weixing/:currentMedia/other/:otherMedia", framePath:"/cm-sites/pms/wechat/weixing.html"},

            {path:"/library/download/downloadList",  component:DownLoadTaskList},
            {path:"/library/label/label/:labelType", framePath:"/cm-sites/pms/library/label/label.html"},

            {path:"/website/wangzhan/:currentMedia/audit/list/:mediaCode/:auditViewId/:activitiType", component:AuditStoryList},
            {path:"/website/wangzhan/:currentMedia/audit/setting/:type/:mediaCode", component:AuditViewList},

            {path:"/zyktableList", component:ZykTabList, frame:NO_FRAME},
            {path:"/zyknewsDetail/:id/:resourceType", component:NewsDetail, frame:NO_FRAME},
            {path:"/zyktableList/:height", component:ZykTabList, frame:NO_FRAME},

            // 融媒
            {path:"/mediaFusion/index/:mediaId", component:MediaFusionIndex},
            {path:"/mediaFusion/column/:mediaId", component: ColumnList},
            {path:"/mediaFusion/article/:columnId/:mediaId", component: ArticleList},
            {path:"/mediaFusion/article/:mediaId/", component: NotColumnPage},
            {path:"/mediaFusion/splashList", component:Splash },
            {path:"/mediaFusion/pointsRule", component:PointsRule },
            {path:"/mediaFusion/pointsManagement", component:PointsManagement },
            {path:"/mediaFusion/honorManagement", component:HonorManagement },

            {path:"/mediaFusion/rm", component:RmList },
            {path:"/mediaFusion/userManage", component:UserList },
            {path:"/mediaFusion/convenienceServe", component:ConvenienceServeList },
            {path:"/mediaFusion/opinionManage", component:OpinionManageList },
            {path:"/mediaFusion/messagePush", component:MessagePushList },
            {path:"/mediaFusion/appIndex", component:MediaFusionIndex},
            {path:"/mediaFusion/sysManagement/rmDeliverRelation", component:RmDeliverRelation },
            {path:"/mediaFusion/video/:mediaId", framePath:"/cm-sites/pms/mediaFusion/video.html"},
            {path:"/mediaFusion/audio", framePath:"/cm-sites/pms/mediaFusion/audio.html"},
            {path:"/mediaFusion/broadcast", framePath:"/cm-sites/pms/mediaFusion/broadcast.html"},
            {path:"/mediaFusion/all", framePath:"/cm-sites/pms/mediaFusion/all.html"},
            {path:"/mediaFusion/fansMangeList", framePath:"/cm-sites/pms/mediaFusion/fansMangeList.html"},
            {path:"/mediaFusion/messagePushList", framePath:"/cm-sites/pms/mediaFusion/messagePushList.html"},
            {path:"/mediaFusion/specialTopic", framePath:"/cm-sites/pms/mediaFusion/specialTopic.html"},

            {path:"/shengao/listNew", framePath:"/cm-sites/pms/shengao/listNew.html?actButtonId=2"},
            {path:"/interviewTask/interviewTask/:type", framePath:"/cm-sites/pms/interviewTask/interviewTask.html"},
            {path:"/interviewTask/interviewTask/:type/:clueId", framePath:"/cm-sites/pms/interviewTask/interviewTask.html"},
            {path:"/interviewEvent/interviewEventList", framePath:"/cm-sites/pms/interviewEvent/interviewEventList.html"},
            {path:"/interviewEvent/interviewEventList/:eventType", framePath:"/cm-sites/pms/interviewEvent/interviewEventList.html"},
            {path:"/interviewEvent/interviewEventList/:eventType", framePath:"/cm-sites/pms/interviewEvent/interviewEventList.html"},
            {path:"/appointment/appointment", framePath:"/cm-sites/pms/appointment/appointment.html"},
            {path:"/appointment/appointment/fromClue/:clueId", framePath:"/cm-sites/pms/appointment/appointment.html"},
            {path:"/clue/clue", framePath:"/cm-sites/pms/clue/clue.html"},
            {path:"/topicSelect/topicSelect", framePath:"/cm-sites/pms/topicSelection/clue.html"},
            {path:"/topicSelectManager/topicSelectManager", framePath:"/cm-sites/pms/topicSelectManager/clue.html"},
            {path:"/reporter/reporter", framePath:"/cm-sites/pms/reporter/reporter.html"},
            {path:"/reporter/statistics/account/:account", framePath:"/cm-sites/pms/reporter/statistics.html"},
            {path:"/notice/notice1", framePath:"/cm-sites/pms/notice/notice.html"},//老版通知公告
            {path:"/notice/notice", component:Notice, componentProps:{isPms:true} },//新改的通知公告
            {path:"/statistics/statistics", framePath:"/cm-sites/pms/statistics/statistics.html"},
            {path:"/oms/index", framePath:"/cm-sites/pms/oms/index.html"},
            //校报
            {path:"/paper/storyList", framePath:"/cm-sites/pms/paper/storyList.html"},
            {path:"/paper/paper", framePath:"/cm-sites/pms/paper/paper.html"},
            {path:"/paper/paper/:editPaperId", framePath:"/cm-sites/pms/paper/paper.html"},
            {path:"/paper/reviewSheet", framePath:"/cm-sites/pms/paper/reviewSheet.html"},

            {path:"/library/story/storyList", framePath:"/cm-sites/pms/library/story/storyList.html"},
            {path:"/library/picture/pictureList", framePath:"/cm-sites/pms/library/picture/pictureList.html"},
            {path:"/library/quanbuwenjian/:resourceComponent/:currentId", component:StorageList},
            {path:"/library/only/show/:resourceComponent/:currentId", component:StorageList, frame:NO_FRAME},
            {path:"/library/video/videoList", framePath:"/cm-sites/pms/library/video/videoList/story/listNew/.html"},
            {path:"/library/audio/audioList", framePath:"/cm-sites/pms/library/audio/audioList.html"},
            {path:"/library/file/fileList", framePath:"/cm-sites/pms/library/file/fileList.html"},
            {path:"/library/upload/uploadList", framePath:"/cm-sites/pms/library/upload/uploadList.html"},
            {path:"/library/collection/collectionList", framePath:"/cm-sites/pms/library/collection/collectionList.html"},
            {path:"/library/share/shareList", framePath:"/cm-sites/pms/library/share/shareList.html"},
            {path:"/library/downloadApplication/list", framePath:"/cm-sites/pms/downloadApplication/downloadApplicationList.html"},
            {path:"/library/downloadApplication/listJump/:jumpType", framePath:"/cm-sites/pms/downloadApplication/downloadApplicationList.html"},
            {path:"/library/label/label", framePath:"/cm-sites/pms/library/label/label.html"},
            {path:"/library/audit/activityList", framePath:"/cm-sites/pms/library/audit/activityList.html"},
            {path:"/library/audit/resourceList/:activityId", framePath:"/cm-sites/pms/library/audit/resourceList.html"},

            {path:"/website/addContribute/:eiditStoryId/:processInstanceId/:processDefinitionId/:currentMediaCode/:taskId/:actButtonId/:lastId", framePath:"/cm-sites/pms/addContribute/addContributeNews.html"},
            {path:"/writing/writingNew/:eiditStoryId/:processInstanceId/:actButtonId", framePath:"/cm-sites/pms/writing/writingNew.html"},
            {path:"/interviewTask/interviewTaskdetail/:interviewId", framePath:"/cm-sites/pms/interviewTask/interviewTaskdetail.html"},
            // {path:"/interviewTask/interviewTask/:clueId", framePath:"/cm-sites/pms/interviewTask/interviewTask.html"},
            {path:"/wechat/editMaterial/:materialId/:currentMedia/:actButtonId/:processInstanceId", framePath:"/cm-sites/pms/wechat/editMaterial.html"},

            //资源库内容页
            {path:"/library/story/storyInfo/:resource/:type", framePath:"/cm-sites/pms/library/story/storyInfo.html"},
            {path:"/library/picture/pictureInfo", framePath:"/cm-sites/pms/library/picture/pictureInfo.html"},
            {path:"/library/picture/pictureInfo/:resource", framePath:"/cm-sites/pms/library/picture/pictureInfo.html"},
            {path:"/library/picture/pictureInfo/:resource/:type", framePath:"/cm-sites/pms/library/picture/pictureInfo.html"},
            {path:"/library/video/videoInfo", framePath:"/cm-sites/pms/library/video/videoInfo.html"},
            {path:"/library/video/videoInfo/:resource", framePath:"/cm-sites/pms/library/video/videoInfo.html"},
            {path:"/library/video/videoInfo/:resource/:type", framePath:"/cm-sites/pms/library/video/videoInfo.html"},
            {path:"/library/audio/audioInfo", framePath:"/cm-sites/pms/library/audio/audioInfo.html"},
            {path:"/library/audio/audioInfo/:resource", framePath:"/cm-sites/pms/library/audio/audioInfo.html"},
            {path:"/library/audio/audioInfo/:resource/:type", framePath:"/cm-sites/pms/library/audio/audioInfo.html"},
            {path:"/library/file/fileInfo", framePath:"/cm-sites/pms/library/file/fileInfo.html"},
            {path:"/library/file/fileInfo/:resource", framePath:"/cm-sites/pms/library/file/fileInfo.html"},
            {path:"/library/file/fileInfo/:resource/:type", framePath:"/cm-sites/pms/library/file/fileInfo.html"},

            //通知公告内容页
            {path:"/notice/noticeadd", framePath:"/cm-sites/pms/notice/noticeadd.html"},
            {path:"/notice/noticemodify/:notificationId", framePath:"/cm-sites/pms/notice/noticemodify.html"},
            {path:"/notice/noticedetail/:notificationId", framePath:"/cm-sites/pms/notice/noticedetail.html"},

            //拾取文章
            {path:"/addContribute/addContributeNews/:eiditStoryId/:currentMediaCode/:actButtonId", framePath:"/cm-sites/pms/addContribute/addContributeNews.html"},
            //查看文章
            {path:"/addContribute/addContribute/eiditStoryId/:eiditStoryId/processInstanceId/:processInstanceId/actButtonId/:actButtonId", framePath:"/cm-sites/pms/addContribute/addContributeNews.html"},
            {path:"/addContribute/addContributeNews/:eiditStoryId/:currentMediaCode/:fromZyk/:actButtonId", framePath:"/cm-sites/pms/addContribute/addContributeNews.html"},
            {path:"/addContribute/addContributeNews/:actButtonId/:currentMediaCode", framePath:"/cm-sites/pms/addContribute/addContributeNews.html"},
            {path:"/addContribute/addContribute/:eiditStoryId/:processInstanceId/:currentMediaCode/:taskId/:actButtonId/:lastId", framePath:"/cm-sites/pms/addContribute/addContributeNews.html"},
            {path:"/website/addContribute/:eiditStoryId/:currentMediaCode/:processInstanceId/:actButtonId", framePath:"/cm-sites/pms/addContribute/addContributeNews.html"},
            {path:"/writing/writingNew/:eiditStoryId", framePath:"/cm-sites/pms/writing/writingNew.html"},
            {path:"/writing/writingNew/eiditStoryId/:eiditStoryId/processInstanceId/:processInstanceId/interviewId/:interviewId/actButtonId/:actButtonId", framePath:"/cm-sites/pms/writing/writingNew.html"},
            {path:"/interview/addContribute/addContributeNews/:processDefinitionName/:interviewId/:actButtonId", framePath:"/cm-sites/pms/addContribute/addContributeNews.html"},
            {path:"/interview/addContribute/addContributeNews/eiditStoryId/:eiditStoryId/:interviewId/:actButtonId", framePath:"/cm-sites/pms/addContribute/addContributeNews.html"},
            {path:"/interview/addContribute/addContribute/eiditStoryId/:eiditStoryId", framePath:"/cm-sites/pms/addContribute/addContributeNews.html"},
            {path:"/interview/addContribute/addContribute/eiditStoryId/:eiditStoryId/processInstanceId/:processInstanceId/interviewId/:interviewId/actButtonId/:actButtonId", framePath:"/cm-sites/pms/addContribute/addContributeNews.html"},
            {path:"/interview/addContribute/addContribute/eiditStoryId/:eiditStoryId/interviewId/:interviewId/actButtonId/:actButtonId", framePath:"/cm-sites/pms/addContribute/addContributeNews.html"},
            {path:"/interview/addContribute/addContribute/eiditStoryI/wechat/weixingd/:eiditStoryId/currentMediaCode/:currentMediaCode/interviewId/:interviewId/actButtonId/:actButtonId", framePath:"/cm-sites/pms/addContribute/addContributeNews.html"},
            {path:"/interview/addContribute/addContributeNews/eiditStoryId/:eiditStoryId/processInstanceId/:processInstanceId/interviewId/:interviewId/actButtonId/:actButtonId", framePath:"/cm-sites/pms/addContribute/addContributeNews.html"},
            {path:"/appointment/addContribute/addContribute/eiditStoryId/:eiditStoryId/processInstanceId/:processInstanceId/processDefinitionId/:processDefinitionId/currentMediaCode/:currentMediaCode/taskId/:taskId/actButtonId/:actButtonId/lastId/:lastId", framePath:"/cm-sites/pms/addContribute/addContributeNews.html"},
            {path:"/appointment/addContribute/addContribute/:appointmentReceiverId/:eiditStoryId/:processInstanceId/:processDefinitionId/:currentMediaCode/:taskId/:actButtonId/:lastId", framePath:"/cm-sites/pms/addContribute/addContributeNews.html"},

            //融媒内容页
            {path:"/mediaFusion/datamanage", component:DataManage},
            {path:"/mediaFusion/columnmanage", component:ColumnManage},
            {path:"/mediaFusion/atlasdetail", framePath:"/cm-sites/pms/mediaFusion/atlasdetail.html"},
            {path:"/mediaFusion/atlasdetail/mfId/:mfId", framePath:"/cm-sites/pms/mediaFusion/atlasdetail.html"},
            {path:"/mediaFusion/videodetail", framePath:"/cm-sites/pms/mediaFusion/videodetail.html"},
            {path:"/mediaFusion/videodetail/mfId/:mfId", framePath:"/cm-sites/pms/mediaFusion/videodetail.html"},
            {path:"/mediaFusion/audiodetail", framePath:"/cm-sites/pms/mediaFusion/audiodetail.html"},
            {path:"/mediaFusion/audiodetail/mfId/:mfId", framePath:"/cm-sites/pms/mediaFusion/audiodetail.html"},
            {path:"/videoStoryEditor/videoStoryEditor/storyid/:storyid/status/:status", framePath:"/cm-sites/pms/videoStory/videoStoryEditor/videoStoryEditor.html"},
            {path:"/videoStory/videoStoryEditor/storyid/:storyid/status/:status", framePath:"/cm-sites/pms/videoStory/videoStoryEditor/videoStoryEditor.html"},


            // 图文消息
            {path:"/wechat/weixing/:currentMedia/stuff", component:StuffList},
            // 135编辑
            {path:"/wechat/135Edit/:mediaCode/:stuffId", component:EditorComponents135, frame:NO_FRAME},
            // 查看图文弹窗
            {path:"/wechat/weixing/edit/:materialId/:stuffId", component:ContentModal, frame:NO_FRAME},
            // 选择群发方式弹窗
            {path:"/wechat/send/:mediaCode", component:WeiChatTagSelect, frame:NO_FRAME},
            // 微信编辑
            {path:"/wechat/edit/:materialId/:mediaCode", component:EditMaterial, frame:NO_FRAME},
            // // 发布记录-
            // {path:"/wechat/publishRecord/:currentMedia", component:PublishRecord},
            // 粉丝管理
            {path:"/wechat/weixing/:currentMedia/weiChatFans", component:WeChatFansManage},

            //微信tab页
            {path:"/wechat/weixing/:currentMedia/tabindex/:tabindex", framePath:"/cm-sites/pms/wechat/weixing.html"},
            //栏目内容页-文章源
            {path:"/website/wangzhan/:currentMedia/news/:type/:treeId/:treeContentId", component:MyStory},
            //栏目内容页-图片源
            {path:"/website/wangzhan/:mediaCode/image/:type/:treeId/:treeContentId", component:ImageSourceList},
            //栏目内容页-链接源
            {path:"/website/wangzhan/:mediaCode/url/:type/:treeId/:treeContentId", component:LinkSourceList},
            //稿费管理
            {path:"/storyMoney/list", component:StoryMoneyList},
            //用户管理
            {path:"/user/list", framePath:"/cm-sites/pms/user/list.html"},

            //媒体预约
            {path:"/external/externalClue", framePath:"/cm-sites/pms/mediaReservation/external/externalClue.html"},
            {path:"/internal/internalClue", framePath:"/cm-sites/pms/mediaReservation/internal/internalClue.html"}

        ]
    }
};
export default config;
